if($('.inspiratorFeed').length){
    var inspiratorFeed = $('.inspiratorFeed');
    var dataUrl = inspiratorFeed.data('json');
    if (dataUrl) {
        $.ajax({
            url: dataUrl,
            type: 'GET',
            dataType: 'json',
            success: function(response) {
                localStorage.setItem('inspiratorData', JSON.stringify(response));
                processInspiratorData(response);
            },
            error: function(xhr, status, error) {
                console.error("Error fetching data:", status, error);
            }
        });
    } else {
        var storedData = localStorage.getItem('inspiratorData');
        if (storedData) {
            var parsedData = JSON.parse(storedData);
            processInspiratorData(parsedData);
        }
    }
    function processInspiratorData(data) {
        data.forEach(function(item) {
            var itemImage = item.url
            if(itemImage.includes('/www/')){
                itemImageNew = itemImage
            }
            else{
                itemImage = itemImage.split('/upload/')[1]
                itemImageNew = 'https://inspirator.shopcode.cz/www/upload/'+itemImage
            }
            var itemHtml = '<div class="itemInner">';
            itemHtml += '<img src="' +itemImageNew+ '" alt="Image">';
            itemHtml += '<div class="points">';
            item.points.forEach(function(point) {
                itemHtml += '<div class="point" style="top:' + point.top + '%; left:' + point.left + '%;">';
                    itemHtml += '<span class="pointCircle"></span>'
                    itemHtml += '<div class="description" style="display:none;">'
                        itemHtml += '<div class="descriptionInner">'
                            itemHtml += '<span class="close"></span>'
                            itemHtml += '<div class="image"><img src="' + point.product.image + '" alt="' + point.product.name + '"></div>'
                            itemHtml += '<span class="title"><a href="' + point.product.url + '">' + point.product.name + '</a></span>'
                            itemHtml += '<div class="prices">'
                                if(point.product.actionPrice !== 0){
                                    itemHtml += '<span class="Actionprice">'+Number(point.product.price).ShoptetFormatAsCurrency()+'</span>'
                                    itemHtml += '<span class="price">'+Number(point.product.actionPrice).ShoptetFormatAsCurrency()+'</span>'
                                }
                                else{
                                    itemHtml += '<span class="price">'+Number(point.product.price).ShoptetFormatAsCurrency()+'</span>'
                                }
                               
                            itemHtml += '</div>'
                            itemHtml += '<div class="text-center"><a href="'+ point.product.url +'" class="btn btn-default">Detail</a></div>'
                        itemHtml += '</div>';
                    itemHtml += '</div>';
                itemHtml += '</div>';
            });
            itemHtml += '</div></div>';
            $('.inspiratorFeed').append(itemHtml);
        });
    }
    $(document).on('click', '.point .pointCircle', function() {
        var $currentPoint = $(this).closest('.point');
        $('.point').not($currentPoint).each(function() {
            var $otherPoint = $(this);
            if ($otherPoint.hasClass('openPoint')) {
                $otherPoint.removeClass('openPoint');
                $otherPoint.find('.description').slideUp(500);
            }
        });
        $currentPoint.toggleClass('openPoint');
        $currentPoint.find('.description').slideToggle(500);
    });
    $(document).on('click', '.point .close', function(){
        $(this).closest('.point').find('.description').slideToggle(500)
        $(this).closest('.point').toggleClass('openPoint')
    })
}